import { createContext, useContext, RefObject } from 'react';

/**
 * Exposes the app's main scrollable content element (`.page-content-scrollable`) so descendants
 * can observe or scroll it via an explicit ref, instead of reaching for it with DOM `.closest()`
 * lookups that couple behaviour to a CSS class and ancestry.
 */
const PageScrollContainerContext = createContext<RefObject<HTMLDivElement | null> | null>(null);

export const PageScrollContainerProvider = PageScrollContainerContext.Provider;

export const usePageScrollContainerRef = () => useContext(PageScrollContainerContext);
